import { render, staticRenderFns } from "./sub-category-edit.vue?vue&type=template&id=0326df72&"
import script from "./sub-category-edit.vue?vue&type=script&lang=js&"
export * from "./sub-category-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports